// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.action-menu_menu-container_cySHr {
    display: flex;
    flex-direction: column-reverse;
    transition: 0.2s;
    position: relative;
}

.action-menu_button_jiQSo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    background: var(--looks-secondary);
    outline: none;
    border: none;
    transition: background-color 0.2s;
}

button::-moz-focus-inner {
    border: 0;
}

.action-menu_button_jiQSo:hover {
    background: var(--extensions-primary);
}

.action-menu_button_jiQSo:active {
    padding: inherit;
}

.action-menu_button_jiQSo.action-menu_coming-soon_LuCWA:hover {
    background: var(--data-primary);
}

.action-menu_main-button_QgooT {
    border-radius: 100%;
    width: 2.75rem;
    height: 2.75rem;
    box-shadow: 0 0 0 4px var(--looks-transparent);
    z-index: 46;
    transition: transform, box-shadow 0.5s;
}

.action-menu_main-button_QgooT:hover {
  transform: scale(1.1);
  box-shadow: 0 0 0 6px var(--looks-transparent);
}

.action-menu_main-icon_LMEEx {
    width: calc(2.75rem - 1rem);
    height: calc(2.75rem - 1rem);
}

[dir="rtl"] .action-menu_main-icon_LMEEx {
    transform: scaleX(-1);
}

.action-menu_more-buttons-outer_m4LBq {
    /*
        Need to use two divs to set different overflow x/y
        which is needed to get animation to look right while
        allowing the tooltips to be visible.
    */
    overflow-y: hidden;

    background: var(--looks-secondary-dark);
    border-top-left-radius: 2.25rem;
    border-top-right-radius: 2.25rem;
    width: 2.25rem;
    margin-left: calc((2.75rem - 2.25rem) / 2);
    margin-right: calc((2.75rem - 2.25rem) / 2);

    position: absolute;
    bottom: calc(2.75rem);

    margin-bottom: calc(2.75rem / -2);
    padding-bottom: calc(2.75rem / 2);
}

.action-menu_more-buttons_zqWJI {
    max-height: 0;
    transition: max-height 1s;
    overflow-x: visible;
    display: flex;
    flex-direction: column;
    z-index: 10; /* @todo justify */
}

.action-menu_file-input_vDbAk {
    display: none;
}

.action-menu_expanded_HsEB9 .action-menu_more-buttons_zqWJI {
    max-height: 1000px; /* Arbitrary, needs to be a value in order for animation to run */
}

.action-menu_force-hidden_QgQPY .action-menu_more-buttons_zqWJI {
    display: none; /* This property does not animate */
}

.action-menu_more-buttons_zqWJI:first-child { /* Round off top button */
    border-top-right-radius: 2.25rem;
    border-top-left-radius: 2.25rem;
}

.action-menu_more-button_LKcK_ {
    width: 2.25rem;
    height: 2.25rem;
    background: var(--looks-secondary-dark);
}

.action-menu_more-icon_lC0Bl {
    width: calc(2.25rem - 1rem);
    height: calc(2.25rem - 1rem);
}

.action-menu_coming-soon_LuCWA .action-menu_more-icon_lC0Bl {
    opacity: 0.5;
}

/*
    @todo needs to be refactored with coming soon tooltip overrides.
    The "!important"s are for the same reason as with coming soon, the library
    is not very easy to style.
*/

.action-menu_tooltip_ekPXb {
    background-color: var(--extensions-primary) !important;
    opacity: 1 !important;
    border: 1px solid hsla(0, 0%, 0%, .1) !important;
    box-shadow: 0 0 .5rem hsla(0, 0%, 0%, .25) !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

.action-menu_tooltip_ekPXb:after {
    background-color: var(--extensions-primary);
}

.action-menu_coming-soon-tooltip_PmU2a {
    background-color: var(--data-primary) !important;
}

.action-menu_coming-soon-tooltip_PmU2a:after {
    background-color: var(--data-primary) !important;
}

.action-menu_tooltip_ekPXb {
    border: 1px solid hsla(0, 0%, 0%, .1) !important;
    border-radius: calc(0.5rem / 2) !important;
    box-shadow: 0 0 .5rem hsla(0, 0%, 0%, .25) !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    z-index: 47 !important;
}

.action-menu_tooltip_ekPXb:after {
    content: "";
    border-top: 1px solid hsla(0, 0%, 0%, .1) !important;
    border-left: 0 !important;
    border-bottom: 0 !important;
    border-right: 1px solid hsla(0, 0%, 0%, .1) !important;
    border-radius: 0.125rem;
    height: 0.5rem !important;
    width: 0.5rem !important;
}

.action-menu_tooltip_ekPXb.place-left:after {
    margin-top: -0.25rem !important;
    right: -0.25rem !important;
    transform: rotate(45deg) !important;
}

.action-menu_tooltip_ekPXb.place-right:after {
    margin-top: -0.25rem !important;
    left: -0.25rem !important;
    transform: rotate(-135deg) !important;
}

.action-menu_tooltip_ekPXb.place-top:after {
    margin-right: -0.25rem !important;
    bottom: -0.25rem !important;
    transform: rotate(135deg) !important;
}

.action-menu_tooltip_ekPXb.place-bottom:after {
    margin-left: -0.25rem !important;
    top: -0.25rem !important;
    transform: rotate(-45deg) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/action-menu/action-menu.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,2DAA2D;IAC3D,kCAAkC;IAClC,aAAa;IACb,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,8CAA8C;IAC9C,WAAW;IACX,sCAAsC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;;;;KAIC;IACD,kBAAkB;;IAElB,uCAAuC;IACvC,+BAA+B;IAC/B,gCAAgC;IAChC,cAAc;IACd,0CAA0C;IAC1C,2CAA2C;;IAE3C,kBAAkB;IAClB,qBAAqB;;IAErB,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,kBAAkB;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB,EAAE,iEAAiE;AACzF;;AAEA;IACI,aAAa,EAAE,mCAAmC;AACtD;;AAEA,8CAA4B,yBAAyB;IACjD,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;CAIC;;AAED;IACI,sDAAsD;IACtD,qBAAqB;IACrB,gDAAgD;IAChD,qDAAqD;IACrD,sEAAsE;AAC1E;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;IAChD,0CAA0C;IAC1C,qDAAqD;IACrD,sEAAsE;IACtE,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,oDAAoD;IACpD,yBAAyB;IACzB,2BAA2B;IAC3B,sDAAsD;IACtD,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,oCAAoC;AACxC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.menu-container {\n    display: flex;\n    flex-direction: column-reverse;\n    transition: 0.2s;\n    position: relative;\n}\n\n.button {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background: var(--looks-secondary);\n    outline: none;\n    border: none;\n    transition: background-color 0.2s;\n}\n\nbutton::-moz-focus-inner {\n    border: 0;\n}\n\n.button:hover {\n    background: var(--extensions-primary);\n}\n\n.button:active {\n    padding: inherit;\n}\n\n.button.coming-soon:hover {\n    background: var(--data-primary);\n}\n\n.main-button {\n    border-radius: 100%;\n    width: 2.75rem;\n    height: 2.75rem;\n    box-shadow: 0 0 0 4px var(--looks-transparent);\n    z-index: 46;\n    transition: transform, box-shadow 0.5s;\n}\n\n.main-button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 0 0 6px var(--looks-transparent);\n}\n\n.main-icon {\n    width: calc(2.75rem - 1rem);\n    height: calc(2.75rem - 1rem);\n}\n\n[dir=\"rtl\"] .main-icon {\n    transform: scaleX(-1);\n}\n\n.more-buttons-outer {\n    /*\n        Need to use two divs to set different overflow x/y\n        which is needed to get animation to look right while\n        allowing the tooltips to be visible.\n    */\n    overflow-y: hidden;\n\n    background: var(--looks-secondary-dark);\n    border-top-left-radius: 2.25rem;\n    border-top-right-radius: 2.25rem;\n    width: 2.25rem;\n    margin-left: calc((2.75rem - 2.25rem) / 2);\n    margin-right: calc((2.75rem - 2.25rem) / 2);\n\n    position: absolute;\n    bottom: calc(2.75rem);\n\n    margin-bottom: calc(2.75rem / -2);\n    padding-bottom: calc(2.75rem / 2);\n}\n\n.more-buttons {\n    max-height: 0;\n    transition: max-height 1s;\n    overflow-x: visible;\n    display: flex;\n    flex-direction: column;\n    z-index: 10; /* @todo justify */\n}\n\n.file-input {\n    display: none;\n}\n\n.expanded .more-buttons {\n    max-height: 1000px; /* Arbitrary, needs to be a value in order for animation to run */\n}\n\n.force-hidden .more-buttons {\n    display: none; /* This property does not animate */\n}\n\n.more-buttons:first-child { /* Round off top button */\n    border-top-right-radius: 2.25rem;\n    border-top-left-radius: 2.25rem;\n}\n\n.more-button {\n    width: 2.25rem;\n    height: 2.25rem;\n    background: var(--looks-secondary-dark);\n}\n\n.more-icon {\n    width: calc(2.25rem - 1rem);\n    height: calc(2.25rem - 1rem);\n}\n\n.coming-soon .more-icon {\n    opacity: 0.5;\n}\n\n/*\n    @todo needs to be refactored with coming soon tooltip overrides.\n    The \"!important\"s are for the same reason as with coming soon, the library\n    is not very easy to style.\n*/\n\n.tooltip {\n    background-color: var(--extensions-primary) !important;\n    opacity: 1 !important;\n    border: 1px solid hsla(0, 0%, 0%, .1) !important;\n    box-shadow: 0 0 .5rem hsla(0, 0%, 0%, .25) !important;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n}\n\n.tooltip:after {\n    background-color: var(--extensions-primary);\n}\n\n.coming-soon-tooltip {\n    background-color: var(--data-primary) !important;\n}\n\n.coming-soon-tooltip:after {\n    background-color: var(--data-primary) !important;\n}\n\n.tooltip {\n    border: 1px solid hsla(0, 0%, 0%, .1) !important;\n    border-radius: calc(0.5rem / 2) !important;\n    box-shadow: 0 0 .5rem hsla(0, 0%, 0%, .25) !important;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n    z-index: 47 !important;\n}\n\n.tooltip:after {\n    content: \"\";\n    border-top: 1px solid hsla(0, 0%, 0%, .1) !important;\n    border-left: 0 !important;\n    border-bottom: 0 !important;\n    border-right: 1px solid hsla(0, 0%, 0%, .1) !important;\n    border-radius: 0.125rem;\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n}\n\n.tooltip:global(.place-left):after {\n    margin-top: -0.25rem !important;\n    right: -0.25rem !important;\n    transform: rotate(45deg) !important;\n}\n\n.tooltip:global(.place-right):after {\n    margin-top: -0.25rem !important;\n    left: -0.25rem !important;\n    transform: rotate(-135deg) !important;\n}\n\n.tooltip:global(.place-top):after {\n    margin-right: -0.25rem !important;\n    bottom: -0.25rem !important;\n    transform: rotate(135deg) !important;\n}\n\n.tooltip:global(.place-bottom):after {\n    margin-left: -0.25rem !important;\n    top: -0.25rem !important;\n    transform: rotate(-45deg) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-container": `action-menu_menu-container_cySHr`,
	"menuContainer": `action-menu_menu-container_cySHr`,
	"button": `action-menu_button_jiQSo`,
	"coming-soon": `action-menu_coming-soon_LuCWA`,
	"comingSoon": `action-menu_coming-soon_LuCWA`,
	"main-button": `action-menu_main-button_QgooT`,
	"mainButton": `action-menu_main-button_QgooT`,
	"main-icon": `action-menu_main-icon_LMEEx`,
	"mainIcon": `action-menu_main-icon_LMEEx`,
	"more-buttons-outer": `action-menu_more-buttons-outer_m4LBq`,
	"moreButtonsOuter": `action-menu_more-buttons-outer_m4LBq`,
	"more-buttons": `action-menu_more-buttons_zqWJI`,
	"moreButtons": `action-menu_more-buttons_zqWJI`,
	"file-input": `action-menu_file-input_vDbAk`,
	"fileInput": `action-menu_file-input_vDbAk`,
	"expanded": `action-menu_expanded_HsEB9`,
	"force-hidden": `action-menu_force-hidden_QgQPY`,
	"forceHidden": `action-menu_force-hidden_QgQPY`,
	"more-button": `action-menu_more-button_LKcK_`,
	"moreButton": `action-menu_more-button_LKcK_`,
	"more-icon": `action-menu_more-icon_lC0Bl`,
	"moreIcon": `action-menu_more-icon_lC0Bl`,
	"tooltip": `action-menu_tooltip_ekPXb`,
	"coming-soon-tooltip": `action-menu_coming-soon-tooltip_PmU2a`,
	"comingSoonTooltip": `action-menu_coming-soon-tooltip_PmU2a`
};
export default ___CSS_LOADER_EXPORT___;
